var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreparationsDisActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 7,
    fill: "#C1C3C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2353 9.58824C21.2353 8.71252 20.5228 8 19.6471 8H14.353C13.4772 8 12.7647 8.71252 12.7647 9.58824V10.1176H21.2353V9.58824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7059 22.8236H22.2941V15.4118H11.7059V22.8236ZM17.1059 16.6824L17.953 17.3177L17 18.5883H19.1177L16.8941 21.553L16.0471 20.9177L17 19.6471H14.8824L17.1059 16.6824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3953 12.2353H20.1765V11.1765H13.8235V12.2353H13.6047C12.5577 12.2353 11.7059 13.0871 11.7059 14.1341V14.3529H22.2941V14.1341C22.2941 13.0871 21.4423 12.2353 20.3953 12.2353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7059 24.1013C11.7059 25.1483 12.5577 26.0001 13.6047 26.0001H20.3953C21.4423 26.0001 22.2941 25.1483 22.2941 24.1013V23.8824H11.7059V24.1013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparationsDisActive);
export default __webpack_public_path__ + "static/media/PreparationsDisActive.bb9273505a379c616e7bc7038a9fb5df.svg";
export { ForwardRef as ReactComponent };